<nav class="vitrine-navbar" [class.scrolled]="isScrolled || isMenuOpen">
  <div class="nav-container">
    <div class="nav-content">

      <!-- Logo -->
      <div class="nav-logo" routerLink="/" (click)="closeMenu()">
        <img src="assets/layout/images/logo-sgmao.jpg" alt="SGMAO" loading="lazy">
        <span class="nav-logo-text">SGMAO</span>
      </div>

      <!-- Links (desktop + mobile) -->
      <div class="nav-links" [class.open]="isMenuOpen">

        <!-- Dropdowns -->
        <div class="nav-dropdown-wrapper" *ngFor="let dropdown of navDropdowns">
          <button
            class="nav-dropdown-trigger"
            [class.active]="activeDropdown === dropdown.key"
            (click)="toggleDropdown(dropdown.key, $event)">
            {{ dropdown.label }}
            <i class="pi pi-angle-down nav-chevron" [class.rotated]="activeDropdown === dropdown.key"></i>
          </button>

          <div class="nav-dropdown-panel" [class.open]="activeDropdown === dropdown.key">
            <button
              class="nav-dropdown-item"
              *ngFor="let item of dropdown.items"
              (click)="item.action(); closeMenu()">
              <div class="dropdown-item-icon">
                <i [class]="item.icon"></i>
              </div>
              <div class="dropdown-item-text">
                <span class="item-label">{{ item.label }}</span>
                <span class="item-desc" *ngIf="item.description">{{ item.description }}</span>
              </div>
            </button>
          </div>
        </div>

        <!-- Simple links -->
        <a class="nav-link" routerLink="/public/apropos" (click)="closeMenu()">À propos</a>
        <a class="nav-link" (click)="goToContact()">Contact</a>

        <!-- CTAs -->
        <div class="nav-ctas">
          <button class="btn-ghost" (click)="goToLogin()">Se connecter</button>
          <button class="btn-primary" (click)="goToRegister()">
            Essai gratuit <i class="pi pi-arrow-right"></i>
          </button>
        </div>
      </div>

      <!-- Mobile hamburger -->
      <button class="nav-toggle" [class.open]="isMenuOpen" (click)="toggleMenu()" aria-label="Menu">
        <span></span>
        <span></span>
        <span></span>
      </button>

    </div>
  </div>
</nav>
